import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation, useParams } from "react-router-dom";
import { I18nProvider } from "@/i18n";
import Layout from "@/components/site/Layout";
import Home from "@/pages/Home";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookiePolicy from "@/pages/CookiePolicy";
import Terms from "@/pages/Terms";
import ThankYou from "@/pages/ThankYou";
import ScrollToTop from "@/components/site/ScrollToTop";
import "@/App.css";

const SUPPORTED = ["mx", "en"];

function LangGate({ children }) {
  const { lang } = useParams();
  const isValid = SUPPORTED.includes(lang);
  useEffect(() => {
    if (isValid) {
      document.documentElement.lang = lang === "mx" ? "es-MX" : "en";
    }
  }, [lang, isValid]);
  if (!isValid) return <Navigate to="/mx" replace />;
  return <I18nProvider lang={lang}>{children}</I18nProvider>;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Navigate to="/mx" replace />} />
          <Route path="/thank_you" element={<ThankYou />} />
          <Route path=":lang" element={<LangGate><Layout /></LangGate>}>
            <Route index element={<Home />} />
            <Route path="privacy-policy" element={<PrivacyPolicy />} />
            <Route path="cookie-policy" element={<CookiePolicy />} />
            <Route path="terms" element={<Terms />} />
          </Route>
          <Route path="*" element={<Navigate to="/mx" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
